// extracted by mini-css-extract-plugin
export default {"container":"_2oyQ_qG9ZFyKkXi7Zli6XY","banner":"_3SF2tSkUl6DdrH1qbktAIt","text":"_1rpK4Gp_tZcK5_EWYw4Phc","button":"_6kp0HYnxvlT2dyEggfuy5"};